import * as React from 'react';

import * as styles from './sendMessageButton.css';

export const SendMessageButton = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['button']}>{props.children}</div>;
};
